// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"dc7d5310","280":"74b9f464","857":"1b6abd0c","924":"f5e3c7eb","956":"5212e116","999":"8f59b8b8"}[chunkId] + ".chunk.css";
};